<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M2.91668 0H11.0834C12.6942 0 14 1.30583 14 2.91668V11.0834C14 12.6942 12.6942 14 11.0833 14H2.91668C1.30583 14 0 12.6942 0 11.0833V2.91668C0 1.30583 1.30583 0 2.91668 0Z"
      fill="white"
    />
  </svg>
</template>
